/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { gql, useLazyQuery } from '@apollo/client';

export const useContestSubscription = () => {
    

    const CONTEST_SUBSCRIPTION_QUERY = gql`
   query ContestSubscription($request: ContestSubscriptionRequest) {
  contestSubscription(request: $request) {
    contestNotification {
      userContestUpdate
    }
  }
}`;

   const [contestSubscription, contestData] = useLazyQuery(CONTEST_SUBSCRIPTION_QUERY)

   return  {contestSubscription, contestData}

}